// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {TableGameLeaderboardBody} from '@app/features/table_game_leaderboard/components/TableGameLeaderboardBody';
import styles from '@app/features/table_game_leaderboard/components/TableGameLeaderboardModal.module.css';
import {LEADERBOARDS_DESCRIPTOR} from '@app/features/table_game_leaderboard/utils/TableGameLeaderboardMessages';
import {Tabs} from '@app/features/ui/tabs/Tabs';
import type {TableGameRankedKind} from '@fluxer/constants/src/TableGameConstants';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useState} from 'react';

type LeaderboardTab = 'guild' | 'global';

const GUILD_TAB_DESCRIPTOR = msg({
	message: 'This community · weekly',
	comment: 'Table game leaderboards: tab with the weekly points board of the current community.',
});
const GLOBAL_TAB_DESCRIPTOR = msg({
	message: 'All of {productName}',
	comment: 'Table game leaderboards: tab with the season boards of every player. {productName} is the app name.',
});
export const TableGameLeaderboardModal = observer(function TableGameLeaderboardModal({
	guildId = null,
	initialGame,
}: {
	guildId?: string | null;
	initialGame?: TableGameRankedKind;
}) {
	const {i18n} = useLingui();
	const [tab, setTab] = useState<LeaderboardTab>(guildId ? 'guild' : 'global');
	return (
		<Modal.Root size="small" className={styles.modalRoot} data-flx="table-game-leaderboard.modal.root">
			<Modal.Header title={i18n._(LEADERBOARDS_DESCRIPTOR)} data-flx="table-game-leaderboard.modal.header">
				{guildId && (
					<Tabs
						tabs={[
							{key: 'guild', label: i18n._(GUILD_TAB_DESCRIPTOR)},
							{key: 'global', label: i18n._(GLOBAL_TAB_DESCRIPTOR, {productName: PRODUCT_NAME})},
						]}
						activeTab={tab}
						onTabChange={setTab}
						data-flx="table-game-leaderboard.modal.tabs"
					/>
				)}
			</Modal.Header>
			<TableGameLeaderboardBody
				guildId={tab === 'guild' ? guildId : null}
				initialGame={initialGame}
				data-flx="table-game-leaderboard.modal.body"
			/>
		</Modal.Root>
	);
});
